module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('div', {
    staticClass: "container header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._m(1), _vm._v(" "), _c('iframe', {
    staticClass: "github-btn",
    attrs: {
      "src": ("//ghbtns.com/github-btn.html?user=xudafeng&repo=" + (_vm.pkg.name) + "&type=watch&count=true"),
      "title": "Star on GitHub"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": ("//www.npmjs.com/" + (_vm.pkg.name))
    }
  }, [_c('span', {
    staticClass: "version"
  }, [_vm._v("v" + _vm._s(_vm.pkg.version))])])])]), _vm._v(" "), _c('Ribbon', _vm._b({}, 'Ribbon', _vm.ribbon, false))], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('h1', [_vm._v("AutoR"), _c('em', [_vm._v("e")]), _vm._v("sponsiv"), _c('em', [_vm._v("e")]), _vm._v(" Vu"), _c('em', [_vm._v("e")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_c('div', {
    staticClass: "first"
  }, [_vm._v("Magic")]), _vm._v(" "), _c('p', [_vm._v("Responsive Layout Library For Vue")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56cdecae"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./homepage/header.vue
// module id = 33
// module chunks = 0